import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { clear_auth, set_auth } from "../../reducers/Auth";
import { Helmet } from "react-helmet";
import RefreshIcon from "../../assets/icons/refresh.svg";
import moment from "moment/moment";
import { Bar } from "react-chartjs-2";
import { lineOptions } from '../../constants/chartData'
import Chart from "react-google-charts";
import { PERMISSIONS } from "../../helper/permissionHelper";
import { withPageAccess } from "../common/ProtectedPage";
import { TourContext } from "../guideComponent/guideTourProvicer";

export class Pemantauan extends Component {
    static contextType = TourContext;
    constructor(props) {
        super(props);
        let currentDate = new Date();
        let currentYear = currentDate. getFullYear();
        const currentMonth = currentDate.getMonth() + 1;
        this.state = {
            selectedBulan: currentMonth.toString().padStart(2, '0') // Format dua digit
        };
        this.state = {
            data: [],
            selectedBulanTahun: moment().format('MM'),
            selectedBulan: moment().format('MM'),
            perusahaan: [],
            selectedYear: currentYear,
            selectedTahun: currentYear,
            absensiTerlambat: [],
            absensiTepatWaktu: [],
            absensi: [],
            karyawan: [],
            loading: true,
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleBulanTahunChange = this.handleBulanTahunChange.bind(this);
        this.handleBulan = this.handleBulan.bind(this);
        this.handleTahun = this.handleTahun.bind(this);
        this.resetFilter = this.resetFilter.bind(this);
        this.resetFilterTerlambat = this.resetFilterTerlambat.bind(this);
        this.resetFilterTepatWaktu = this.resetFilterTepatWaktu.bind(this);
        this.handleYearChange = this.handleYearChange.bind(this)
    }

    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        })
    }
    getMonthName(monthValue) {
        const months = [
            "Januari", "Februari", "Maret", "April", "Mei", "Juni",
            "Juli", "Agustus", "September", "Oktober", "November", "Desember"
        ];

        if (monthValue >= 1 && monthValue <= 12) {
            return months[monthValue - 1];
        } else {
            return "Bulan tidak valid";
        }
    }

    generateOptions() {
        const now = new Date();
        const currentMonth = now.getMonth() + 1;
        const monthsToShow = 6;
        const options = [];

        for (let i = 0; i < monthsToShow; i++) {
            const monthValue = currentMonth - i > 0 ? currentMonth - i : currentMonth - i + 12;
            options.push(
                <option key={monthValue} value={monthValue.toString().padStart(2, '0')}>
                    {this.getMonthName(monthValue)}
                </option>
            );
        }
        return options;
    }

    resetFilter(event) {
        let currentDate = new Date();
        let currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth() + 1;
        this.setState({
                data: [],
                absensin: [],
                selectedYear: currentYear,
                selectedMonth: currentMonth,
                loading: true,
            }, () => this.loadDataAbsensi()
        )
    }
    resetFilterTerlambat(event) {
        let currentDate = new Date();
        let currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth() + 1;
        this.setState({
                data: [],
                absensin: [],
                selectedYear: currentYear,
                selectedMonth: currentMonth,
                loading: true,
            }, () => this.loadData()
        )
    }

    resetFilterTepatWaktu(event) {
        let currentDate = new Date();
        let currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth() + 1;
        this.setState({
                data: [],
                absensin: [],
                selectedYear: currentYear,
                selectedMonth: currentMonth,
                loading: true,
            }, () => this.loadDataTepatWaktu()
        )
    }

    handleBulan = (event) => {
        this.setState({ selectedBulanTahun: event.target.value, loading: true }, () => {
            this.loadData();
        });
    };

    handleBulanTahunChange = (event) => {
        this.setState({ selectedBulan: event.target.value, loading: true  }, () => {
            this.loadDataAbsensi();
        });
    };

    handleTahun = (event) => {
        this.setState({ selectedYear: event.target.value, loading: true  }, () => {
            this.loadData();
        });
    };

    handleYearChange = (event) => {
        this.setState({ selectedTahun: event.target.value, loading: true  }, () => {
            this.loadDataAbsensi();
        });
    };

    handleBulanTepatWaktu = (event) => {
        this.setState({ selectedBulanTahun: event.target.value, loading: true }, () => {
            this.loadDataTepatWaktu();
        });
    };

    handleTahunTepatWaktu = (event) => {
        this.setState({ selectedYear: event.target.value, loading: true  }, () => {
            this.loadDataTepatWaktu();
        });
    };

    loadData() {
        let form = {
            tahun: this.state.selectedYear,
            bulan: this.state.selectedBulanTahun
        };
        this.props.request('presensi/pemantauan-terlambat-v2', form, 'POST')
            .then(response => {
                var tanggal = [];
                var terlambat = [];
                var nama = [];
                response.data.map((item, index) => {
                    tanggal.push((item.tanggal !== null ? item.tanggal : 0));
                    terlambat.push((item.terlambat !== null ? item.terlambat : 0));
                    nama.push((item.nama !== null ? item.nama : 0));
                });
                if (response.success) {
                    this.setState({
                        absensiTerlambat: {
                            tanggal: tanggal,
                            terlambat: terlambat,
                            namaKaryawan: nama,
                        },
                        loading: false
                    })
                }
            })
    }

    loadDataTepatWaktu() {
        let form = {
            tahun: this.state.selectedYear,
            bulan: this.state.selectedBulanTahun
        };
        this.props.request('presensi/pemantauan-tepat-waktu-v2', form, 'POST')
            .then(response => {
                var tanggal = [];
                var tepatWaktu = [];
                var nama = [];
                response.data.map((item, index) => {
                    tanggal.push((item.tanggal !== null ? item.tanggal : 0));
                    tepatWaktu.push((item.tepatWaktu !== null ? item.tepatWaktu : 0));
                    nama.push((item.nama !== null ? item.nama : 0));
                });
                if (response.success) {
                    this.setState({
                        absensiTepatWaktu: {
                            tanggal: tanggal,
                            tepatWaktu: tepatWaktu,
                            namaKaryawan: nama,
                        },
                        loading: false
                    })
                }
            })
    }

    loadDataAbsensi() {
        this.setState({
            loading: true
        });
        let form = {
            year: this.state.selectedTahun,
            month: this.state.selectedBulan
        };
        this.props.request("list-absensiv3", form, 'POST')
            .then(response => {
                var tanggal = [];
                var tepatWaktu = [];
                var terlambat = [];
                var izin = [];
                response.map((item, index) => {
                    tanggal.push((item.tanggal !== null ? item.tanggal : 0));
                    tepatWaktu.push((item.masuk !== null ? item.masuk : 0));
                    terlambat.push((item.terlambat !== null ? item.terlambat : 0));
                    izin.push((item.izin !== null ? item.izin : 0))
                });
                this.setState({
                    absensi: {
                        tanggal: tanggal,
                        tepatWaktu: tepatWaktu,
                        terlambat: terlambat,
                        izin: izin,
                    },
                    loading: false
                })
            });
    }

    loadDataKaryawan() {
        this.setState({
            loading: true
        });
        let form = {};
        this.props.request("dashboard", form, 'POST')
            .then(response => {
                if (response.success) {
                    const isKaryawanNotNull = response.data.karyawan !== null;

                    this.setState({
                        data: response,
                        perusahaan: isKaryawanNotNull ? response.data : {
                            ...response.data,
                            karyawan: {
                                karyawan_laki_laki: 0,
                                karyawan_perempuan: 0,
                                total_karyawan: 0,
                                sisa_karyawan: 0,
                            }
                        }
                    });
                } else {
                    this.setState({
                        loading: false
                    });
                }
            }).catch(error => {
            console.error("Error loading data:", error);
            this.setState({
                loading: false
            });
        });
    }

    // loadCheck() {
    //     let form = {
    //         perusahaan_id: this.props.user.perusahaan_id
    //     }
    //     this.props.request("check-guide-data", form, "POST")
    //         .then((response) => {
    //             if (response.success) {
    //                 this.setState({
    //                     karyawan: response.karyawan
    //                 }, () => {
    //                     if (this.props.user.perusahaan.status === "new" && this.props.user.perusahaan.perusahaan_bidang !== null && this.props.user.perusahaan.perusahaan_alamat !== null && this.props.user.perusahaan.perusahaan_telp !== null) {
    //                         this.setState({
    //                             progresModal: true
    //                         })
    //                     }
    //                 })
    //             }
    //         })
    // }

    componentDidMount() {
        this.loadData()
        this.loadDataAbsensi()
        this.loadDataKaryawan()
        // this.loadCheck()

        setTimeout(() => {
            this.tourSteps = [];

            const totalKaryawan = this.state.perusahaan?.karyawan?.total_karyawan ?? 0;
            if (totalKaryawan === 0) {
                this.tourSteps.push({
                    selector: '.monitor-laporan-absen',
                    title: 'Belum Ada Data Kehadiran',
                    content: 'Belum ada data kehadiran karyawan. Pastikan karyawan sudah melakukan presensi atau periksa kembali filter periode yang dipilih.',
                });
            } else {
                this.tourSteps.push({
                    selector: '.monitor-laporan-absen',
                    title: 'Laporan Absen Semua Karyawan',
                    content: `Terdapat ${totalKaryawan} karyawan tercatat. Grafik ini menampilkan rekap kehadiran mencakup kategori Tepat Waktu, Terlambat, dan Izin.`,
                });
            }

            this.tourSteps.push(
                {
                    selector: '.monitor-laporan-terlambat',
                    title: 'Laporan 5 Karyawan Terlambat Teratas',
                    content: 'Grafik ini menampilkan karyawan dengan keterlambatan terbanyak pada periode yang dipilih.',
                },
                {
                    selector: '.monitor-laporan-tepat-waktu',
                    title: 'Laporan 5 Karyawan Tepat Waktu Teratas',
                    content: 'Grafik ini menampilkan karyawan paling disiplin yang paling sering hadir tepat waktu.',
                },
                {
                    selector: '.monitor-limit-karyawan',
                    title: 'Laporan Limit Karyawan',
                    content: `Menampilkan jumlah karyawan aktif dibandingkan batas maksimum paket Anda. Pastikan jumlah karyawan tidak melebihi limit yang tersedia.`,
                },
                {
                    selector: '.monitor-jenis-kelamin',
                    title: 'Perbandingan Jenis Kelamin',
                    content: 'Grafik ini menampilkan persentase komposisi karyawan berdasarkan jenis kelamin di perusahaan Anda.',
                },
            );

            const {setSteps, setCurrent, setActive} = this.context;
            setSteps(this.tourSteps);
            setCurrent(0);
            setActive(true);
        }, 500)
    }

    render() {
        const dataAbsenTerlambat = {
            labels: this.state.absensiTerlambat.namaKaryawan,
            datasets: [
                {
                    label: 'Terlambat',
                    legend: 'none',
                    data: this.state.absensiTerlambat.terlambat,
                    borderColor: "#ffba5b",
                    backgroundColor: "#ff9100",
                    borderWidth: 2
                }
            ]
        };
        const dataAbsenTepatWaktu = {
            labels: this.state.absensiTepatWaktu.namaKaryawan,
            datasets: [
                {
                    label: 'Tepat Waktu',
                    legend: 'none',
                    data: this.state.absensiTepatWaktu.tepatWaktu,
                    borderColor: "#75ff43",
                    backgroundColor: "#75ff43",
                    borderWidth: 2
                }
            ]
        };
        const dataAbsen = {
            labels: this.state.absensi.tanggal,
            datasets: [{
                label: 'Tepat Waktu',
                legend: 'none',
                data: this.state.absensi.tepatWaktu,
                borderColor: "#75ff43",
                backgroundColor: "#75ff43",
                borderWidth: 2
            },
                {
                    label: 'Terlambat',
                    legend: 'none',
                    data: this.state.absensi.terlambat,
                    borderColor: "#ff4343",
                    backgroundColor: "#ff4343",
                    borderWidth: 2
                },
                {
                    label: 'Izin',
                    legend: 'none',
                    data: this.state.absensi.izin,
                    borderColor: "#ffe643",
                    backgroundColor: "#ffe643",
                    borderWidth: 2
                },
            ]
        };
        const limitOption = {
            title: "",
            pieHole: 0.5,
            slices: [{
                color: "#EFEFEF"
            },
                {
                    color: "#057CE4"
                },
            ],
            tooltip: {
                showColorCode: false
            },
            chartArea: {
                width: '360px',
                height: '100%'
            },
            legend: "none"
        };
        const genderOption = {
            title: "",
            pieHole: 0.5,
            slices: [{
                color: "#057CE4"
            },
                {
                    color: "#FF9C00"
                },
            ],
            tooltip: {
                showColorCode: false
            },
            chartArea: {
                width: '360px',
                height: '100%'
            },
            legend: "none"
        };
        let perbandinganlaki = 0
        let perbandinganperempuan = 0
        if(!this.state.loading && this.state.perusahaan && this.state.perusahaan.karyawan){
            perbandinganlaki = !this.state.loading && !this.state.perusahaan.karyawan ? 0 : this.state.perusahaan.karyawan.karyawan_laki_laki / this.state.perusahaan.karyawan.total_karyawan * 100;
            perbandinganperempuan = !this.state.loading && !this.state.perusahaan.karyawan ? 0 : this.state.perusahaan.karyawan.karyawan_perempuan / this.state.perusahaan.karyawan.total_karyawan * 100;
        }
        return(
            <Fragment>
                <Helmet>
                    <meta charSet="utf-8"/>
                    <title>Monitor Perusahaan - Presensi</title>
                    <meta name="description" content="Daftar Monitor"/>
                </Helmet>
                <div className="container-fluid pt-4">
                    <div className='row'>
                        <div className='col-md-12' style={{
                            fontWeight: 400,
                            fontSize: "12px",
                            lineHeight: "16px",
                            color: "#5D6F80"
                        }}>Presensi Admin Panel
                        </div>
                    </div>
                    <div className='row mb-4'>
                        <div className='col-md-12' style={{
                            fontWeight: 700,
                            fontSize: "24px",
                            lineHeight: "36px",
                            color: "#143B5E"
                        }}>Monitor Perusahaan
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className="col-xl-9 col-md-9">
                            <div className="card">
                                <div className="card-body monitor-laporan-absen">
                                    <div className="row mb-3 pt-3">
                                        <div className="col-md-4 d-flex">
                                            <h4> Laporan Absen Semua Karyawan </h4>
                                        </div>
                                        <div className='col-md-2'>
                                            <label style={{fontSize: '13px', alignContent: 'flex-end'}}>Filter
                                                Tahun:</label>
                                            <select name="year" className="form-control descending"
                                                    value={this.state.selectedTahun}
                                                    onChange={this.handleYearChange}>
                                                <option key={2026} value={2026}>2026</option>
                                                <option key={2025} value={2025}>2025</option>
                                                <option key={2024} value={2024}>2024</option>
                                                <option key={2023} value={2023}>2023</option>
                                                <option key={2022} value={2022}>2022</option>
                                            </select>
                                        </div>
                                        <div className='col-md-4'>
                                            <label style={{fontSize: '13px', alignContent: 'flex-end'}}>Filter
                                                Bulan :</label>
                                            <select name="month" className="form-control descending"
                                                    value={this.state.selectedBulan}
                                                    onChange={this.handleBulanTahunChange}>
                                                {this.generateOptions()}
                                            </select>
                                        </div>
                                        <div className='col-md-2 pengumuman-col-filter'>
                                            <label style={{fontSize: '13px', alignContent: 'flex-end'}}>Reset
                                                Filter :</label>
                                            <div className='d-flex flex-row flex-nowrap'>
                                                <button className='pengumuman-button-refresh'
                                                        onClick={this.resetFilter}>
                                                    <img alt='' src={RefreshIcon}/>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={
                                        "col mb-2"
                                    }>
                                        <div className="market-chart">
                                            <Bar data={dataAbsen}
                                                 options={lineOptions}
                                                 width={"100%"}
                                                 height={500}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-body monitor-laporan-terlambat">
                                    <div className="col">
                                        <div className='row'>
                                            <div className="col-md-6 d-flex">
                                                <h4> Laporan 5 Karyawan Terlambat Teratas </h4>
                                            </div>
                                            <div className='col-md-2'>
                                                <label style={{fontSize: '13px', alignContent: 'flex-end'}}>Filter
                                                    Tahun:</label>
                                                <select name="year" className="form-control descending"
                                                        value={this.state.selectedYear}
                                                        onChange={this.handleTahun}>
                                                    <option key={2024} value={2024}>2024</option>
                                                    <option key={2025} value={2025}>2025</option>
                                                    <option key={2026} value={2026}>2026</option>
                                                    <option key={2023} value={2023}>2023</option>
                                                    <option key={2022} value={2022}>2022</option>
                                                </select>
                                            </div>
                                            <div className='col-md-2'>
                                                <label style={{fontSize: '13px', alignContent: 'flex-end'}}>Filter
                                                    Bulan :</label>
                                                <select name="month" className="form-control descending"
                                                        value={this.state.selectedBulanTahun}
                                                        onChange={this.handleBulan}>
                                                    {this.generateOptions()}
                                                </select>
                                            </div>
                                            <div className='col-md-2 pengumuman-col-filter'>
                                                <label style={{fontSize: '13px', alignContent: 'flex-end'}}>Reset
                                                    Filter :</label>
                                                <div className='d-flex flex-row flex-nowrap'>
                                                    <button className='pengumuman-button-refresh'
                                                            onClick={this.resetFilterTerlambat}>
                                                        <img alt='' src={RefreshIcon}/>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col">
                                            <div className="market-chart">
                                                <Bar data={dataAbsenTerlambat}
                                                     options={lineOptions}
                                                     width={"100%"}
                                                     height={500}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-body monitor-laporan-tepat-waktu">
                                    <div className="col">
                                        <div className='row'>
                                            <div className="col-md-6 d-flex">
                                                <h4> Laporan 5 Karyawan Tepat Waktu Teratas </h4>
                                            </div>
                                            <div className='col-md-2'>
                                                <label style={{fontSize: '13px', alignContent: 'flex-end'}}>Filter
                                                    Tahun:</label>
                                                <select name="year" className="form-control descending"
                                                        value={this.state.selectedYear}
                                                        onChange={this.handleTahunTepatWaktu}>
                                                    <option key={2024} value={2024}>2024</option>
                                                    <option key={2025} value={2025}>2025</option>
                                                    <option key={2026} value={2026}>2026</option>
                                                    <option key={2023} value={2023}>2023</option>
                                                    <option key={2022} value={2022}>2022</option>
                                                </select>
                                            </div>
                                            <div className='col-md-2'>
                                                <label style={{fontSize: '13px', alignContent: 'flex-end'}}>Filter
                                                    Bulan :</label>
                                                <select name="month" className="form-control descending"
                                                        value={this.state.selectedBulanTahun}
                                                        onChange={this.handleBulanTepatWaktu}>
                                                    {this.generateOptions()}
                                                </select>
                                            </div>
                                            <div className='col-md-2 pengumuman-col-filter'>
                                                <label style={{fontSize: '13px', alignContent: 'flex-end'}}>Reset
                                                    Filter :</label>
                                                <div className='d-flex flex-row flex-nowrap'>
                                                    <button className='pengumuman-button-refresh'
                                                            onClick={this.resetFilterTepatWaktu}>
                                                        <img alt='' src={RefreshIcon}/>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col">
                                            <div className="market-chart">
                                                <Bar data={dataAbsenTepatWaktu}
                                                     options={lineOptions}
                                                     width={"100%"}
                                                     height={500}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-md-3">
                            <div className="card">
                                <div className="card-body monitor-limit-karyawan">
                                    <div>
                                        <div className="order-graph sm-order-space">
                                            <div className="row"
                                                 style={
                                                     {
                                                         justifyContent: 'space-between'
                                                     }
                                                 }>
                                                <h6> Laporan Limit Karyawan </h6> <
                                                h6> {
                                                this.state.perusahaan && this.state.perusahaan.karyawan ? this.state.perusahaan.karyawan.total_karyawan : 0
                                            }
                                                / {this.state.perusahaan && this.state.perusahaan.karyawan ? this.state.perusahaan.karyawan.total_karyawan + this.state.perusahaan.karyawan.sisa_karyawan : 0}</h6>
                                            </div>
                                            {
                                                this.state.loading ?
                                                    'Sedang Memuat Data...' :
                                                    <>
                                                        <div className="peity-chart-dashboard text-center"
                                                             style={
                                                                 {
                                                                     alignItems: 'center'
                                                                 }
                                                             }>
                                                            <Chart
                                                                chartType="PieChart"
                                                                data={
                                                                    [
                                                                        ['Laporan', 'Limit Karyawan'],
                                                                        ['Sisa Slot Karyawan', this.state.perusahaan && this.state.perusahaan.karyawan ? this.state.perusahaan.karyawan.sisa_karyawan : 0],
                                                                        ['Karyawan', this.state.perusahaan && this.state.perusahaan.karyawan ? this.state.perusahaan.karyawan.total_karyawan : 0],
                                                                    ]
                                                                }
                                                                options={
                                                                    limitOption
                                                                }
                                                                graph_id="LimitChart"
                                                                width={
                                                                    "100%"
                                                                }
                                                                height={
                                                                    "180px"
                                                                }
                                                                legend_toggle/>
                                                        </div>
                                                    </>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-body monitor-jenis-kelamin">
                                    <div>
                                        <div className="order-graph sm-order-space">
                                            <h6> Perbandingan Jenis Kelamin </h6> {
                                            this.state.loading ?
                                                'Sedang Memuat Data...' :
                                                <>
                                                    <div className="peity-chart-dashboard text-center">
                                                        <Chart
                                                            chartType="PieChart"
                                                            data={
                                                                [
                                                                    ['Perbandingan', 'Gender'],
                                                                    ['Laki-laki', this.state.perusahaan && this.state.perusahaan.karyawan ? this.state.perusahaan.karyawan.karyawan_laki_laki : 0],
                                                                    ['Perempuan', this.state.perusahaan && this.state.perusahaan.karyawan ? this.state.perusahaan.karyawan.karyawan_perempuan : 0],
                                                                ]
                                                            }
                                                            options={
                                                                genderOption
                                                            }
                                                            graph_id="GenderChart"
                                                            width={
                                                                "100%"
                                                            }
                                                            height={
                                                                "180px"
                                                            }
                                                            legend_toggle/>
                                                    </div>
                                                    <div className="order-graph-bottom sales-location">
                                                        <div className="media">
                                                            <div className="media-body">
                                                                <h6 className="mb-0 mr-0"> Laki - laki < span
                                                                    className="pull-right"> {
                                                                    perbandinganlaki.toFixed(1)
                                                                } % </span></h6></div>
                                                        </div>
                                                        <div className="media">
                                                            <div className="media-body">
                                                                <h6 className="mb-0 mr-0"> Perempuan <span
                                                                    className="pull-right"> {
                                                                    perbandinganperempuan.toFixed(1)
                                                                } % </span></h6></div>
                                                        </div>
                                                    </div>
                                                </>
                                        }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}


const mapStateToProps = state => ({
    user: state.Auth.user,
    api_token: state.Auth.api_token
});

const mapDispatchToProps = dispatch => ({
    clear_auth: () => dispatch(clear_auth()),
    set_auth: (api_token, data) => dispatch(set_auth(api_token, data))
})

export default connect(mapStateToProps, mapDispatchToProps)(withPageAccess(Pemantauan, PERMISSIONS.PEMANTAUAN));
